import(/* webpackMode: "eager" */ "/vercel/path0/src/app/beta/events/[eventSlug]/manage/hosts/page.tsx");
